// extracted by mini-css-extract-plugin
module.exports = {"container":"Detail_container_30_0S","chevron":"Detail_chevron_2jPmf","usersTable":"Detail_usersTable_1mgOm"};